import { environment } from '@env/environment';
import { MapClientScripts } from './maps.models';

export const MAP_CLIENT_SCRIPTS: MapClientScripts[] = [
  {
    name: 'google',
    src: `https://maps.googleapis.com/maps/api/js?key=${environment.CBREGoogleMapsKey}&libraries=places`,
  },
  {
    name: 'gaode',
    src: `https://webapi.amap.com/maps?v=1.3&plugin=AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder&key=${environment.CBREGaodeMapsKey}`,
  },
];
